import { alpha } from "@mui/material";

const SUCCESS = {
  lighter: "#E9FCD4",
  light: "#AAF27F",
  main: "#54D62C",
  dark: "#28A745",
  darker: "#08660D",
  contrastText: "#212B36",
};

const ERROR = {
  lighter: "#FFE7D9",
  light: "#FFA48D",
  main: "#FF4842",
  dark: "#B72136",
  darker: "#7A0C2E",
  contrastText: "#fff",
};

const INFO = {
  main: "#FFC222",
};

export const MAIN_COLOR = "#0060A2";
export const MAIN_COLOR_SECONDARY = "#A4CE4E";
export const COLOR_2 = "#C3002F";
export const COLOR_3 = "#EFEFEF";

export const palette = {
  primary: {
    dark: "#0061A0",
    main: MAIN_COLOR, //#C20E30 primario DS
    main100: alpha(MAIN_COLOR),
    main80: alpha(MAIN_COLOR, 0.8),
    main60: alpha(MAIN_COLOR, 0.6),
    main40: alpha(MAIN_COLOR, 0.4),
    main20: alpha(MAIN_COLOR, 0.2),
    main10: alpha(MAIN_COLOR, 0.1),
    mainHoverBackground: "rgba(66, 164, 245, 0.06)",
    appBarBackground: "#FFFFFF",
    lightContrast: "#FCFCFC",
    darkContrast: "#000000",
    contrastText: "#F2F2F2",
    TableHeader: MAIN_COLOR,
    TableHeader2: MAIN_COLOR,
    text: "#FFFFFF",
    selectMenu: MAIN_COLOR,
    borderASummary: "#EEEEEE",
    mainLyrics: "#FFFFFF",
    tableMain: MAIN_COLOR,
    tableHeadLight: "#F6F6F6",
    tableHeadLightText: "#5E5C5C",
    tableSecondary: "#FFB8B8",
    tableText: "#FFFFFF",
    tableHover: "#F2F2F2",
  },
  secondary: {
    dark: "#000000",
    main: MAIN_COLOR_SECONDARY,
    main100: alpha(MAIN_COLOR_SECONDARY),
    main80: alpha(MAIN_COLOR_SECONDARY, 0.8),
    main60: alpha(MAIN_COLOR_SECONDARY, 0.6),
    main40: alpha(MAIN_COLOR_SECONDARY, 0.4),
    main20: alpha(MAIN_COLOR_SECONDARY, 0.2),
    main10: alpha(MAIN_COLOR_SECONDARY, 0.1),
    lightContrast: "#F7F7F3",
    darkContrast: "#000000",
    contrastText: "#FFFFFF",
    light: "#F4F4F4",
  },
  nabvar: {
    main: MAIN_COLOR,
  },
  check: {
    main: MAIN_COLOR,
    text: "#1E1E1E",
  },
  tab: {
    text: MAIN_COLOR,
  },
  footerBar: {
    main: "#424242",
    text: "#ffffff",
  },
  menuColor: {
    main: MAIN_COLOR, // Color de backgroung
    text: MAIN_COLOR,
  },
  userStyle: {
    icNotificaciones: "#292B30",
    icUser: MAIN_COLOR,
    textDetails: "#292B30",
    textInstruccions: "#292B30",
  },
  iconPrincButton: {
    main: MAIN_COLOR,
    bgIcon: "#FFFFFF",
    text: "#FFFFFF",
  },
  iconNamePrincipal: {
    main: MAIN_COLOR,
    text: "#ffffff",
  },
  linkButton: {
    main: MAIN_COLOR, // color de fondo button
  },
  actorsButton: {
    main: MAIN_COLOR,
    bgIcon: "#FFFFFF",
  },
  status: {
    info: "#000000", // Color de textos detalle
  },
  selectTab: {
    info: MAIN_COLOR, // Tabs selected color
    icon: "#484D58",
    textColor: "#FFFFFF",
    textColor1: "#9C9C9C",
    indicator: MAIN_COLOR,
    border: MAIN_COLOR,
    infoDisabled: "#F6F6F6",
    textColorDisabled: "#000000",
  },
  accordion: {
    main: "#243746 ",
    line: "#FFF0E8",
  },
  borderGray: {
    main: "#484D58",
    line: "#FFF0E8",
  },
  borderGreen: {
    main: "#A3D043",
    line: "#FFF0E8",
  },
  borderRed: {
    main: MAIN_COLOR,
    line: "#FFF0E8",
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  success: { ...SUCCESS },
  error: { ...ERROR },
  info: { ...INFO },
};
